module.exports = __webpack_public_path__ + "static/img/userIcon.9b8404fa.png";